import React from 'react';
import Button from 'reactstrap/lib/Button';
import SettingsStore from '../../../../../Stores/SettingsStore';
import PaymentStore from '../../../../../Stores/PaymentStore';
import ModalStore from '../../../../../Stores/ModalStore';

const CancelNoBalanceSessionBtn = ({ t, session, ...rest }) => {
  const handlePayment = async values => {
    const result = await PaymentStore.cancelNoBalanceSession({ ...values });
    return result;
  };

  const handleCancelSession = () => {
    ModalStore.openModal('cancelSession', {
      onAccept: handlePayment,
      paymentMethods: SettingsStore.settings.paymentsMethods,
      orderId: session.id,
      title: 'Оплата парковочной сессии',
      paymentMessage:
        'Если вы закроете окно оплаты, то оплатить данную сессию вы сможете в блоке "Отложенные парковки"',
      t
    });
  };

  return (
    <Button color="primary" outline onClick={handleCancelSession} {...rest}>
      {'Оплатить'}
    </Button>
  );
};

export default CancelNoBalanceSessionBtn;
